export default "__VITE_ASSET__8afe2605__"